export async function createConversation(
  userId: string,
  mode: "advisory" | "strategic" = "advisory",
  isDraft = false,
  idempotencyKey?: string, // Added idempotency key parameter
): Promise<string | null> {
  try {
    const body: any = { mode }

    if (idempotencyKey) {
      body.idempotencyKey = idempotencyKey
    }

    const response = await fetch("/api/conversations", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })

    if (!response.ok) {
      console.error("Failed to create conversation:", response.statusText)
      return null
    }

    const data = await response.json()

    if (data.cached) {
      console.log("[p0][dedupe] Returned cached conversation:", data.conversation_id.slice(-8))
    }

    return data.conversation_id
  } catch (error) {
    console.error("Error creating conversation:", error)
    return null
  }
}
